//React
import React, { useEffect, useState } from "react";
//Components
import {
  Button,
  Card,
  FlexBox,
  Loader,
  Screen,
  showLoader,
  removeLoader,
  StatusMark,
} from "components";
//Styles
import "./styles.scss";
import { ChangeHistory, getURLParameter, inIframe } from "utils";
import secureLocalStorage from "react-secure-storage";
import { ROUTE_PATH } from "Routes";
//Libraries
import { phone } from "phone";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import cx from "classnames";
import { Player } from "@lottiefiles/react-lottie-player";
//Assets
import Check from "assets/lottie/check.json";
const JS = () => {
  const [iframeSrc, setIFrameSrc] = useState("");
  const [otplessUserData, setOtplessUserData]: any = useState({});
  const [buttonText, setButtonText]: any = useState(
    <FlexBox alignCenter justifyCenter>
      <img src="https://otpless.authlink.me/assets/whatsapp.svg" />
      <p className="font-medium">Continue with WhatsApp</p>
    </FlexBox>
  );
  const [iframeHeight, setIframeHeight] = useState("0");
  const [buttonVisibility, setButtonVisibility] = useState(true);
  const [showButtonLoader, setButtonShowLoader] = useState(true);
  const [removeCarat, setRemoveCarat] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [buttonVariant, setButtonVariant] = useState("");
  const [sessionLink, setSessionLink] = useState("");
  const authLink = "https://otpless.authlink.me/whatsappAuth?flow=IFRAME";

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    const width = document.body.offsetWidth;
    setScreenSize(`${(width * 20) / 100}px`);
    if (inIframe() || getURLParameter("waId")) {
      otplessAuth();
    } else {
      getOutFromAuth();
    }
  }, []);

  const getOutFromAuth = () => {
    document.body.style.removeProperty("height");
    document.body.style.removeProperty("width");
    removeLoader();
    ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
  };

  const setScreenSize = (height, iframeID?) => {
    sendMessage({
      event: iframeID ? "desktopIntialize" : "initialize",
      screen: {
        height,
      },
    });
    document.body.style.height = height;
    document.body.style.width = "100vw";
    setIframeHeight(height);
  };

  const receiveMessage = (event) => {
    if (event?.data?.action) {
      const iframeSize = () => {
        // setScreenSize("200px");
      };

      const otplessState = () =>
        secureLocalStorage.setItem("state", event.data?.otplessState);

      const sessionLink = () => {
        setSessionLink(event.data?.sessionLink);
        setButtonShowLoader(false);
      };

      const eventDataAction = {
        otplessUser: () => otplessUser(event.data?.otplessUser),
        iframeSize,
        otplessState,
        sessionLink,
      };
      eventDataAction[event?.data?.action]?.();
    }
  };

  const successLoader = () => {
    setTimeout(() => {
      setShowSuccess(true);
    }, 6000);
  };

  const otplessUser = (otplessUser) => {
    const data = { ...otplessUser };
    if (data?.metaData) {
      const redirectURI = data.metaData.redirectURI;
      const phoneNumberWithPlus = data.whatsAppNumber.includes("+")
        ? data.whatsAppNumber
        : `+${data.whatsAppNumber}`;
      const phoneNumber = phone(phoneNumberWithPlus, { country: "" });
      //@ts-ignore
      const countryFlag = getUnicodeFlagIcon(phoneNumber.countryIso3);
      setButtonVariant("outline");
      const width = document.body.offsetWidth;
      setScreenSize(`${(width * 26.6) / 100}px`);
      setTimeout(() => {
        setRemoveCarat(true);
      }, 2000);
      setButtonShowLoader(false);
      if (
        secureLocalStorage.getItem("isOTPlessRedirectionAllowed") === "true"
      ) {
        secureLocalStorage.setItem("isOTPlessRedirectionAllowed", "false");
        window.location.href = `${redirectURI}?waId=${secureLocalStorage.getItem(
          "waId"
        )}`;
      } else {
        setIFrameSrc("");
        delete data["metaData"];
        setOtplessUserData(data);
        if (
          secureLocalStorage.getItem("isOTPlessRedirectionAllowed") === "false"
        ) {
          setButtonText(
            <FlexBox alignCenter justifyAround className="w-100">
              <p className="animated fadeInLeft delay-01s country-flag w-10">
                {countryFlag}
              </p>
              <div className="w-50">
                <p
                  className={cx(
                    removeCarat && "remove-carat",
                    "font-medium phone-number"
                  )}
                >
                  {data.whatsAppNumber}
                </p>
              </div>
              <div className="w-10 temp-loader">
                <div className="loader"></div>
              </div>
              <p className="floating-text font-medium">Double Tap to Edit</p>
            </FlexBox>
          );
          setTimeout(() => {
            setButtonText(
              <FlexBox alignCenter justifyAround>
                <p className="country-flag">{countryFlag}</p>
                <p className={cx("font-medium")}>{data.whatsAppNumber}</p>
                <StatusMark status="SUCCESS" />
                <p className="floating-text font-medium">Double Tap to Edit</p>
              </FlexBox>
            );
          }, 2100);
          secureLocalStorage.removeItem("isOTPlessRedirectionAllowed");
          sendOtplessUser(otplessUser);
        } else if (
          secureLocalStorage.getItem("isOTPlessDataSharingAllowed") === "true"
        ) {
          setButtonText(
            <FlexBox alignCenter justifyAround>
              <p className="country-flag">{countryFlag}</p>
              <p className={cx("font-medium")}>{data.whatsAppNumber}</p>
              <StatusMark status="SUCCESS" />
              <p className="floating-text font-medium">Double Tap to Edit</p>
            </FlexBox>
          );
          secureLocalStorage.removeItem("isOTPlessDataSharingAllowed");
          sendOtplessUser(otplessUser);
        } else {
          setButtonText(
            <FlexBox alignCenter justifyAround>
              <p className="country-flag">{countryFlag}</p>
              <p className={cx("font-medium")}>{data.whatsAppNumber}</p>
              <StatusMark status="SUCCESS" />
              <p className="floating-text font-medium">Double Tap to Edit</p>
            </FlexBox>
          );
        }
      }
    } else {
      setButtonShowLoader(false);
      secureLocalStorage.clear();
      const decodeUri = decodeURIComponent(getURLParameter("authPage"));
      setIFrameSrc(
        `https://otpless.com/auth?redirectURI=${decodeUri.split("?")[0]}`
      );
    }
  };

  const otplessAuth = () => {
    //@ts-ignore
    const currentUrl = window.location.href;
    const currentUrlSplit = currentUrl.split("?");
    const params = currentUrlSplit[1];
    const redirectUri = getURLParameter("authPage") || document.referrer;

    const decodeUri = decodeURIComponent(getURLParameter("authPage"));
    const authPageWaId = getURLParameter("waId", decodeUri);

    if (getURLParameter("waId")) {
      showLoader();
      if (document.referrer.includes("authlink.me")) {
        secureLocalStorage.setItem("waId", getURLParameter("waId"));
        secureLocalStorage.setItem("isOTPlessRedirectionAllowed", "true");
        setIFrameSrc(
          `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
            params ? `&${params}` : ""
          }`
        );
        window.history.pushState({}, document.title, currentUrlSplit[0]);
      } else {
        getOutFromAuth();
      }
    } else if (authPageWaId) {
      const bringData = () => {
        secureLocalStorage.setItem("waId", authPageWaId);
        secureLocalStorage.setItem("isOTPlessRedirectionAllowed", "false");
        setIFrameSrc(
          `${authLink}&redirectURI=${encodeURIComponent(
            decodeUri.split("?")[0]
          )}&waId=${authPageWaId}`
        );
        // window.history.pushState({}, document.title, currentUrlSplit[0]);
      };
      if (window.screen.width < 768) {
        if (authPageWaId === secureLocalStorage.getItem("state")) {
          bringData();
        } else {
          secureLocalStorage.clear();
        }
      } else {
        bringData();
      }
    } else if (secureLocalStorage.getItem("waId")) {
      setIFrameSrc(
        `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
          params ? `&${params}` : ""
        }&waId=${secureLocalStorage.getItem("waId")}`
      );
    } else {
      if (window.screen.width < 768) {
        setIFrameSrc(
          `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
            params ? `&${params}` : ""
          }`
        );
      } else {
        setButtonShowLoader(false);
        if (getURLParameter("screen") === "DESKTOP") {
          setScreenSize("300px", "iframe2");
          setButtonVisibility(false);
          setIFrameSrc(
            `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
              params ? `&${params}` : ""
            }`
          );
        }
      }
    }
  };

  const sendOtplessUser = (otplessUser) => {
    const data = otplessUser || otplessUserData;
    const finalData = {
      waName: data.whatsAppName,
      waNumber: data.whatsAppNumber,
      sessonId: data.sessonId,
    };
    sendMessage({
      event: "otplessUser",
      otplessUser: finalData,
    });
  };

  const sendMessage = (data) => {
    //@ts-ignore
    window.parent.postMessage(data, "*");
  };

  const otplessButtonAuth = () => {
    //@ts-ignore
    const currentUrl = window.location.href;
    const currentUrlSplit = currentUrl.split("?");
    let params = currentUrlSplit[1];
    let redirectUri = getURLParameter("authPage") || document.referrer;
    if (secureLocalStorage.getItem("waId")) {
      secureLocalStorage.setItem("isOTPlessDataSharingAllowed", "true");
      setIFrameSrc(
        `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
          params ? `&${params}` : ""
        }&waId=${secureLocalStorage.getItem("waId")}`
      );
    } else {
      if (sessionLink) {
        setButtonShowLoader(true);
        window.parent.location.href = sessionLink;
      } else {
        if (window.screen.width > 768) {
          // setIFrameSrc(
          //   `${authLink}&redirectURI=${encodeURIComponent(redirectUri)}${
          //     params ? `&${params}` : ""
          //   }`
          // );
          // setButtonVisibility(false);
          sendMessage({ event: "desktop" });
        }
      }
    }
  };

  //Return UI
  return (
    <Screen className="auth-screen" screenAnimationClass="no-animation">
      <iframe
        src={iframeSrc}
        id="otpless-js"
        style={{
          transition: "all 0.5s ease-in",
          position: buttonVisibility ? "fixed" : "relative",
          top: buttonVisibility ? "-100px" : "0",
          width: "100vw",
          height: iframeHeight,
          border: "none",
          outline: "none",
          background: "var(--white)",
          boxShadow: "0px 4px 25px var(--shadow-color)",
        }}
        scrolling="no"
      />
      {buttonVisibility && (
        <Button
          className={cx(
            "otpless-button no-animation",
            buttonVariant && "mr-t-15"
          )}
          text={
            showButtonLoader ? (
              <FlexBox alignCenter justifyCenter>
                <div className="loader"></div>
              </FlexBox>
            ) : (
              buttonText
            )
          }
          variant={buttonVariant}
          disabled={showButtonLoader}
          onClick={() => otplessButtonAuth()}
          restrictAnimation
          others={{
            id: "otpless-button",
            hidden: !inIframe(),
            onDoubleClick: () => {
              if (buttonVariant === "outline") {
                setButtonShowLoader(false);
                secureLocalStorage.clear();
                const decodeUri = decodeURIComponent(
                  getURLParameter("authPage")
                );
                window.location.href = `https://otpless.com/auth?redirectURI=${
                  decodeUri.split("?")[0]
                }`;
              }
            },
          }}
        />
      )}
    </Screen>
  );
};

export default JS;
